// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AVvd","icon":"styles_icon__3SirK"};